import {Injectable} from '@angular/core';


@Injectable()
export class TagCommanderService {

    public tagPageSign(contractType: string) {
        const tagParams: object = this.setTagPageName(contractType);

        window['tc_vars']['env_work'] = window['__env']['env'];
        window['tc_vars']['page_name'] = tagParams['pageName'];
        window['tc_vars']['contract_name'] = tagParams['contractName'];

        this.windowsReload();
    }

    public tagOtherPages(): void {
        window['tc_vars']['env_work'] = window['__env']['env'];
        window['tc_vars']['page_name'] = 'index';
        window['tc_vars']['contract_name'] = '';
        this.windowsReload();
    }

    public click(): void {
        window['tc_vars']['click_label'] = `souscription::signer`;
        window['tc_vars']['click_type'] = `navigation`;
        window['tC'].event.click(this, {});
    }

    private windowsReload(): void {
        window['tC'].container.reload();
        window['tC'].event.pageview(this, {});

        window['caReady'] = window['caReady'] || [];

        window['cact'] = function () {
            window['caReady'].push(arguments);
        };
    }

    private setTagPageName(contractType: string): object {
        switch (contractType) {
            case 'AUTO':
            case 'Auto':
                return {
                    pageName: `${contractType.toLowerCase()}::souscription::etape23_signature`,
                    contractName: contractType.toLowerCase()
                };
            case 'GAV-INDIV':
            case 'AAV':
                return {
                    pageName: `${contractType.toLowerCase()}::souscription::signature`,
                    contractName: contractType.toLowerCase()
                };
            case 'PJ':
            case 'MRH':
                return {
                    pageName: `${contractType.toLowerCase()}::souscription::etape4_signature`,
                    contractName: contractType.toLowerCase()
                };
            default: {
                return {
                    pageName: `${contractType.toLowerCase()}::souscription::undefined`,
                    contractName: contractType.toLowerCase()
                };
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/service/tag-commander.service.ts